// @flow
import { OFFERS_GRID } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_OFFER_GRID } from 'Utils/request/requestDictionary';

export const offersGridResolver = {
  name: OFFERS_GRID,
  resolve(appContext: AppContext) {
    const query = `query {
      offers {
        id name image commercialArgument timingArgument legalInformation color description href
      }
    }`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_OFFER_GRID,
      strictErrors: false,
    });
  },
};
